import en from './en.json';
import ar from './ar.json';
import bn from './bn.json';
import es from './es.json';
import fa from './fa.json';
import frCA from './fr-CA.json';
import hi from './hi.json';
import ht from './ht.json';
import hy from './hy.json';
import it from './it.json';
import ja from './ja.json';
import km from './km.json';
import ko from './ko.json';
import pa from './pa.json';
import pl from './pl.json';
import ru from './ru.json';
import th from './th.json';
import tl from './tl.json';
import vi from './vi.json';
import yi from './yi.json';
import zh from './zh.json';
import zhHans from './zh-Hans.json';

const iproovLanguages: Record<string, Record<string, string>> = {
  en,
  ar,
  bn,
  es,
  fa,
  'fr-CA': frCA,
  hi,
  ht,
  hy,
  it,
  ja,
  km,
  ko,
  pa,
  pl,
  ru,
  th,
  tl,
  vi,
  yi,
  zh,
  'zh-Hans': zhHans,
};

export function getIProovLanguage(locale: string): string {
  const strings = iproovLanguages[locale] ?? iproovLanguages['en'];
  return JSON.stringify(strings);
}
